import { IResponse, IServerError } from "@websential/cosmic-v20";
import { AxiosError, AxiosResponse } from "axios";
import http from "../common/http-commons";

export const GlobalSearchServices = {
	getDesiredData: async (
		requestPayload: any
	): Promise<any | IServerError | IResponse> => {
		try {
			
			const response: AxiosResponse<any> = await http.post<any>(
				"/v1/accountants/global-search",
				requestPayload
			);

			if (response.status === 200) {
				return response.data;
			}else if (response.status === 201) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			return { status: false, message: errorMessage, error: true };
		}
	},
};
